import { TabPanel } from "@headlessui/react";
import { CalendarIcon } from "@heroicons/react/24/outline";
import { AppointmentCard } from "./appointment-card";

const NoAppointments = () => {
    return (
        <div className="col-span-full mx-4 mx-auto my-8 text-center md:mx-8">
            <CalendarIcon className="mx-auto size-15" />
            <h3 className="mt-2 mb-3 text-xl/8 font-semibold">
                No appointments found
            </h3>
        </div>
    );
};

export const AppointmentPanel = ({ appointments, upcoming = false }) => {
    return (
        <TabPanel className="grid gap-4">
            {appointments.length === 0 ? (
                <NoAppointments />
            ) : (
                appointments.map((appointment) => (
                    <AppointmentCard
                        key={appointment.appointmentGuid}
                        appointment={appointment}
                        upcoming={upcoming}
                    />
                ))
            )}
        </TabPanel>
    );
};
